const BaseEnum = {
  NAME: "İsim",
  TRADE_NAME: "Ticari Unvan",
  ADDRESS: "Adres",
  TAX_OFFICE: "Vergi Dairesi",
  TAX_NUMBER: "Vergi Numarası",
  EMAIL: "E-posta",
  PHONE: "Telefon",
  SECTOR: "Sektör",
  FACTORY_NAME: "Fabrika Adı",
  FACTORY_MANAGER: "Fabrika Sorumlusu",
  FACTORY_PHONE: "Fabrika Telefon",
  FACTORY_ADDRESS: "Fabrika Adresi",
  PRICE: "Fiyat",
  AMOUNT: "Miktar",
  MATERIAL_TYPE: "Malzeme Türü",
  PAYMENT_TYPE: "Ödeme Türü",
  TERM: "Vade",
  EXPECTED_PAYMENT_DATE: "Beklenen Ödeme Tarihi",
  SIZE: "Boyut",
  CLASSIFICATION: "Sınıflandırma",
  PACKAGING: "Ambalaj",
  REQUESTED_DELIVERY_DATE: "Talep Edilen Teslim Tarihi",
  COMMENT: "Yorum",
  ORDER_FORM_ID: "Sipariş Formu ID",
  STATUS: "Durum",
  CREATED_BY_ID: "Oluşturan ID",
  CREATED_BY_NAME: "Oluşturan Kişi",
  CREATED_BY: "Oluşturan Kişi",
  PRICE_PER_TON: "Ton Başına Fiyat",
  LOGISTICS_STATUS: "Lojistik Durumu",
  LOGISTICS_COMMENT: "Lojistik Yorumu",
  LOGISTICS_PRICE: "Lojistik Fiyatı",
  RESPONSIBLE_USER: "Sorumlu Kişi",
  CUSTOMER_INFORMATION: "Müşteri Bilgileri",
  FACTORY_INFORMATION: "Fabrika Bilgileri",
  ORDER_DETAILS: "Sipariş Detayları",
  LOGISTICS_INFORMATION: "Lojistik Bilgileri",
  PROFI_INFORMATION: "Kullanıcı Bilgileri",
  LOCATIONTR: "TR",
  LOCATION: "Konum",
  LOGISTICS_INVOICE_STATUS: "Lojistik Fatura Durumu",
  SALES_INVOICE_STATUS: "Satış Fatura Durumu",
  SALES_STATUS: "Satış Durumu",
  SALES_COMMENT: "Satış Yorumu",
  SALES_PRICE: "Satış Fiyatı",

  // Rol tanımları
  ROLE_SALES_RESPONSIBLE: "Satış Sorumlusu",
  ROLE_LOGISTICS_OFFICER: "Lojistik Görevlisi",
  ROLE_ACCOUNTANT: "Muhasebeci",
  ROLE_MANAGER: "Yönetici",
  ROLE_RESOURCE: "Kaynak Yöneticisi",
};

export default BaseEnum;
